import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=3f08c67e&scoped=true&"
import script from "./Facebook.vue?vue&type=script&lang=js&"
export * from "./Facebook.vue?vue&type=script&lang=js&"
import style0 from "./Facebook.vue?vue&type=style&index=0&id=3f08c67e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f08c67e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFileInput,VTextField})
